<template>
    <section class="main-section main-attorneys">
        <v-container class="container--large">
            <div class="tit-wrap">
                <h2 class="tit tit--lg tit--point line-height-1">
                    <span>{{ lang === "ko" ? "구성원" : "Attorneys" }}</span>
                    <span class="ko tit--point__circle border-grey" data-aos="zoom-in"></span>
                </h2>
            </div>

            <lawyer-cards mouseOver :lang="lang" class="row--xl main-lawyer-cards" />
        </v-container>
    </section>
</template>

<script>
import LawyerCards from "@/components/dumb/lawyer-cards.vue";

export default {
    components: {
        LawyerCards,
    },
    props: {
        lang: { type: String, default: "ko" },
    },
};
</script>

<style lang="scss" scoped>
.main-attorneys {
    overflow: hidden;
}
::v-deep(.main-lawyer-cards) {
    overflow: visible;
    > [class*="col"] {
        position: relative;
        &:nth-child(1) {
            overflow: visible;
            &::before {
                content: "";
                position: absolute;
                top: -50%;
                left: 0;
                height: 1000vh;
                width: 100%;
                border-left: 1px solid rgba(0, 0, 0, 0.1);
                border-right: 1px solid rgba(0, 0, 0, 0.1);
            }
        }
    }
}
@media (min-width: 768px) {
    ::v-deep(.main-lawyer-cards) {
        overflow: visible;
        > [class*="col"] {
            position: relative;
            &:nth-child(3) {
                &::before {
                    content: "";
                    position: absolute;
                    top: -50%;
                    right: 0;
                    height: 1000vh;
                    width: 100%;
                    border-left: 1px solid rgba(0, 0, 0, 0.1);
                    border-right: 1px solid rgba(0, 0, 0, 0.1);
                }
            }
        }
    }
    .main-lawyer-cards > [class*="col"]:nth-child(1) {
        margin-top: 160px;
        position: relative;
        &::before {
            content: "";
            display: block;
            position: absolute;
            width: 1px;
            height: 120px;
            top: -30px;
            left: 50%;
            transform: translate(-50%, -100%);
            background-color: #000;
        }
    }
    .main-lawyer-cards > [class*="col"]:nth-child(2) {
        margin-top: 80px;
    }
    .main-lawyer-cards > [class*="col"]:nth-child(3n-1):not(:nth-child(2)) {
        margin-top: -80px;
    }
    .main-lawyer-cards > [class*="col"]:nth-child(3n):not(:nth-child(3)) {
        margin-top: -160px;
    }
}
@media (min-width: 1024px) {
    .main-lawyer-cards > [class*="col"]:nth-child(1) {
        margin-top: 320px;
        &::before {
            height: 240px;
            top: -54px;
        }
    }
    .main-lawyer-cards > [class*="col"]:nth-child(2) {
        margin-top: 160px;
    }
    .main-lawyer-cards > [class*="col"]:nth-child(3n-1):not(:nth-child(2)) {
        margin-top: -160px;
    }
    .main-lawyer-cards > [class*="col"]:nth-child(3n):not(:nth-child(3)) {
        margin-top: -320px;
    }
}
</style>